export default __webpack_public_path__ + "static/media/D005.4d727291.jpg";